import { render } from "./AgeGroup.vue?vue&type=template&id=1c8a9cfd"
import script from "./AgeGroup.vue?vue&type=script&lang=js"
export * from "./AgeGroup.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_719f45e5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__